import { Pipe, PipeTransform } from '@angular/core';

import { TellentNavigationGroup, TellentNavigationLink } from '@core/tellent-types';
import { findFirstLink } from '@core/tellent-util';

@Pipe({
  name: 'navigationItemPath',
  pure: true,
})
export class NavigationItemPathPipe implements PipeTransform {
  public transform(item: TellentNavigationGroup | TellentNavigationLink): string {
    return item.type === 'group' ? (findFirstLink(item.children)?.path ?? '#') : item.path;
  }
}
